import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'

import { PdfPage } from '../pdf-reader'

@Component({
  selector: 'mmx-pdf-thumbnail',
  templateUrl: './pdf-thumbnail.component.html',
  styleUrls: ['./pdf-thumbnail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PdfThumbnailComponent {
  @Input()
  public loading: boolean | null = false

  @Input()
  public selected = false

  @Input()
  public page!: Partial<PdfPage>

  @Input()
  public numberOfPages = 0

  @Output()
  public pageSelect = new EventEmitter<MouseEvent>()
}
